import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

function CreateChannel() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  if (!isAuthenticated) {
    navigate('/login');
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!name || name.trim().length < 3) {
      setError('Channel name must be at least 3 characters');
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post('/api/channels', {
        name: name.trim(),
        description: description.trim()
      });
      setSuccess('Channel created successfully');
      setTimeout(() => {
        navigate('/');
      }, 800);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create channel');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ padding: '24px' }}>
      <h2 style={{ marginBottom: '16px' }}>Create your channel</h2>
      <form onSubmit={handleSubmit} style={{ maxWidth: '520px', display: 'grid', gap: '12px' }}>
        <div>
          <label style={{ display: 'block', marginBottom: 6 }}>Channel name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input"
            placeholder="e.g. My Awesome Channel"
            style={{ width: '100%', padding: '10px' }}
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: 6 }}>Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="input"
            rows={4}
            placeholder="Tell viewers what your channel is about"
            style={{ width: '100%', padding: '10px' }}
          />
        </div>
        {error && (
          <div style={{ color: '#b00020' }}>{error}</div>
        )}
        {success && (
          <div style={{ color: '#0a7f33' }}>{success}</div>
        )}
        <div style={{ display: 'flex', gap: 12 }}>
          <button className="btn btn-primary" type="submit" disabled={loading}>
            {loading ? 'Creating...' : 'Create channel'}
          </button>
          <button className="btn" type="button" onClick={() => navigate(-1)} disabled={loading}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateChannel;
